<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div data-app="true" class="data_dict">
      <mrc_ess_iconGroup
        :is_disabled="disabled"
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup>

      <v-form ref="add_dataDict" v-model="add_dataDict">
        <v-card>
          <v-card-text>
            <v-row style="display: flex; justify-content: space-between; align-items: center">
              <v-col cols="6" v-if="$store.state.uuid">
                <mrc_ess_switch
                  v-model="is_used"
                  :label="is_used ? $t('label_To_enable_the') : $t('label_disable')"
                  color="primary"
                  :readonly="disabled"
                ></mrc_ess_switch>
              </v-col>
              <!-- v-if="$store.state.uuid" -->
              <v-col class="d-flex justify-end" cols="6">
                <div v-if="$store.state.uuid">
                  <mrc_ess_svgIcon
                    :key="item"
                    v-for="item in reqParams.client_type"
                    style="font-size: 24px; margin-right: 5px"
                    :icon-class="item"
                  >
                  </mrc_ess_svgIcon>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12">
                <mrc_ess_multiText
                  :label="$t('label_Name_of_the_dictionary') + '*'"
                  :isNational="judegNational('dict_name')"
                  :readonly="disabled"
                  style="width: 100%"
                  :error-messages="
                    $errors('reqParams', 'dict_name', requiredRule.concat(nocharacter))
                  "
                  v-model="reqParams.dict_name"
                ></mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="12">
                <mrc_ess_dictName
                  v-model="reqParams.client_type"
                  :disabled="disabled"
                  :label="$t('label_Client_type') + '*'"
                  :rules="false"
                  :errMsg="$errors('reqParams', 'client_type', requiredRule)"
                  multiple
                  dict_name="client_type"
                  chips
                ></mrc_ess_dictName>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_multiText
                  :label="$t('label_Save_the_value') + '*'"
                  :isNational="judegNational('dict_value')"
                  :readonly="disabled"
                  style="width: 100%"
                  :error-messages="
                    $errors('reqParams', 'dict_value', requiredRule.concat(nocharacter))
                  "
                  v-model="reqParams.dict_value"
                ></mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_multiText
                  :label="$t('label_Show_the_label') + '*'"
                  :isNational="judegNational('dict_label')"
                  :readonly="disabled"
                  style="width: 100%"
                  :error-messages="
                    $errors('reqParams', 'dict_label', requiredRule.concat(nocharacter))
                  "
                  v-model="reqParams.dict_label"
                ></mrc_ess_multiText>
              </v-col>
              <!-- 图标 -->
              <v-col cols="12" sm="6">
                <!-- <mrc_ess_dictName v-model="csuuid"
                                  dict_name="client_type">
                </mrc_ess_dictName> -->
                <mrc_ess_brandupload
                  v-model="reqParams.dict_value_img"
                  :label="$t('label_Photo')"
                  :disabled="disabled"
                  @changeimgSrc="changeimgSrc"
                ></mrc_ess_brandupload>
                <!-- <mrc_ess_autoComplete iconView
                                      :readonly="disabled"
                                      :label="$t('label_imgIcon')"
                                      v-model="reqParams.dict_value_img">
                </mrc_ess_autoComplete> -->
              </v-col>
              <!-- 颜色 -->
              <v-col cols="12" sm="6">
                <mrc_ess_colorPicker v-model="reqParams.dict_value_color" :readonly="disabled">
                </mrc_ess_colorPicker>
              </v-col>
              <v-col cols="12" sm="12">
                <mrc_ess_NumInput
                  :readonly="disabled"
                  :error-messages="
                    $errors('reqParams', 'sequence', between('000-999').concat(requiredRule))
                  "
                  :label="$t('label_The_sorting') + '*'"
                  v-model="reqParams.sequence"
                ></mrc_ess_NumInput>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <mrc_ess_submitBtn
          v-show="!disabled"
          :loading="loading"
          @cancel="cancel"
          @success="success"
        ></mrc_ess_submitBtn>
      </v-form>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getAdd,
  getDataByName,
  getDelete,
  getDetail,
  getChange,
} from '@/service/api/data_dictionary'
import confirm from '@/components/confirm'
import { required, between } from 'vuelidate/lib/validators'
export default {
  components: { confirm },
  props: {},
  data() {
    return {
      csuuid: '',
      loading: false,
      skLoading: true,
      is_change: 1, // 是否有删除的权限
      isLoading: false,
      is_return: false,
      isOpen: false,
      disabled: false,
      add_dataDict: true,
      is_used: true,
      params: {
        '~table~': 'mrbase_sys_dict',
      },
      reqParams: {
        '~table~': 'mrbase_sys_dict',
        uuid: '',
        dict_name: '', // 字典名称
        dict_label: '', // 显示标签
        dict_value: '', // 保存值
        is_used: '', // 是否启用
        client_type: [], // 客户端类型
        sequence: 1, // 排序
        dict_value_color: '',
        dict_value_img: ''
      },
    }
  },
  validations: {
    reqParams: {
      client_type: {
        required,
      },
      dict_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      dict_value: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      dict_label: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      sequence: {
        required,
        between: between(0, 999),
      },
    },
  },
  created() { },
  async mounted() {
    // 有uuid传过来 就是修改
    await this.national('mrbase_sys_dict')
    this.skLoading = true
    // const name = this.$store.getters.subPage_name
    const uuid = this.$route.params.uuid || this.$store.state.uuid
    const is_change =
      this.$route.params.is_change || this.$store.state.is_change
    if (is_change == 1) {
      this.is_change = is_change
    }
    if (uuid) {
      if (this.$store.state.iconstatus) {
        this.disabled = true
      }
      this.reqParams.uuid = uuid

      // 查询详情
      const detailObj = await getDetail({
        uuid: this.reqParams.uuid,
        '~table~': this.params['~table~'],
      })
      detailObj.data.client_type = detailObj.data.client_type
        ? detailObj.data.client_type.split(',')
        : []
      // for(var key in data) {
      //   for(var a in this.reqParams) {
      //     if (key == a) {
      //       this.reqParams[a] = data[key]
      //     }
      //   }
      // }
      this.reqParams = detailObj.data
      // console.log(this.reqParams.client_type,'client-type')
      // this.reqParams.client_type = this.reqParams.client_type ?this.reqParams.client_type.split(',') : []
      this.reqParams.is_used ? (this.is_used = true) : (this.is_used = false)
      this.temp = this.reqParams
    } else {
      this.disabled = false
    }
    this.skLoading = false
  },
  methods: {
    changeimgSrc(v) {
      this.file = v
    },
    // 验证排序是否是数字 不是数字就重置为0
    verifyNum(e) {
      if (!/^[1-9]*$/.test(Number(e.target.value))) {
        this.reqParams.sequence = 1
        e.target.value = 1
      }
    },
    // 点击修改icon
    handleEdit() {
      this.disabled = !this.disabled
    },
    // 点击返回上一页
    handleReturn() {
      this.$router.go(-1)
    },
    // 点击删除此参照
    handleDel() {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') })
        .then(async () => {
          const obj = Object.assign(
            {},
            { uuid: this.reqParams.uuid, '~table~': this.params['~table~'] }
          )
          const res = await getDelete(obj)
          if (res.code == 200) {
            // console.log(this.$parent.desserts.length, this.$parent.params.cpage)
            // if (
            //   this.$parent.desserts.length === 1 &&
            //   this.$parent.params.cpage > 1
            // ) {
            //   this.$parent.params.cpage--
            //   this.$parent.params.totalpage--
            // }

            this.$Message({
              text: this.$t('message_The_deletion_was_successful'),
            })
          }
          this.$router.go(-1)
        })
        .catch(() => { })
      // this.isOpen = true
      // this.showText = this.$t('info.is_del')
    },
    // 取消 修改或者添加
    async cancel() {
      if (this.reqParams.uuid) {
        const detailObj = await getDetail({
          uuid: this.reqParams.uuid,
          '~table~': this.params['~table~'],
        })
        detailObj.data.client_type = detailObj.data.client_type
          ? detailObj.data.client_type.split(',')
          : []
        this.reqParams = detailObj.data
        this.reqParams.is_used ? (this.is_used = true) : (this.is_used = false)
        this.temp = this.reqParams
        this.disabled = true
      }
      else {
        const uuid = this.$route.params.uuid || this.$store.state.uuid
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        })
          .then(() => {
            this.$router.go(-1)
          })
          .catch(() => { })
      }
    },
    // 提交
    async success() {
      this.$v.reqParams.$touch()
      const isSubmit = this.$refs.add_dataDict.validate()
      if (!isSubmit || this.$v.reqParams.$error) {
        return
      }
      this.isLoading = true
      this.reqParams.is_used = this.is_used ? 1 : 0
      // 深拷贝要传的数据，  因为那个客户端呢类型数组要转成字符串
      let obj = this.$clone(this.reqParams)
      obj.client_type = obj.client_type.join()
      // return
      // 修改
      this.loading = true

      await this.$uploadFiles(this.file, {
        function_uuid: this.$store.state.menuFunctionUuid,
        module_uuid:'sysdict',
        uuid: this.$store.state.currentCompanyClientUuid,
      })
        .then(async res => {
          let urllist = ''
          if (typeof (res) == 'object' && res != undefined && res.code == 200) {
            obj.dict_value_img = res.uuid
            urllist = res.uuid
          }

          if (this.reqParams.uuid) {
            // return
            const res = await getChange({
              '~table~': this.params['~table~'],
              uuid: obj.uuid,
              dict_name: obj.dict_name, // 字典名称
              dict_label: obj.dict_label, // 显示标签
              dict_value: obj.dict_value, // 保存值
              is_used: obj.is_used, // 是否启用
              client_type: obj.client_type, // 客户端类型
              sequence: obj.sequence, // 排序
              dict_value_color: obj.dict_value_color,
              dict_value_img: obj.dict_value_img,
            })
            if (res.code == 200) {
              // this.$store.commit(
              //   'newsTips',
              //   this.$t('message_The_operation_was_successful')
              // )
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              })
              this.temp = this.reqParams
              // this.$router.go(-1)
              this.disabled = true
            } else {
              this.$deleteFile(urllist)
            }
            this.loading = false
          } else {
            // 添加
            const res = await getAdd({
              '~table~': this.params['~table~'],
              // uuid: obj.uuid,
              dict_name: obj.dict_name, // 字典名称
              dict_label: obj.dict_label, // 显示标签
              dict_value: obj.dict_value, // 保存值
              is_used: obj.is_used, // 是否启用
              client_type: obj.client_type, // 客户端类型
              sequence: obj.sequence, // 排序
              dict_value_color: obj.dict_value_color,
              dict_value_img: obj.dict_value_img,
            })
            if (res.code == 200) {
              // this.$store.commit(
              //   'newsTips',
              //   this.$t('message_The_operation_was_successful')
              // )
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              })
              this.$router.go(-1)
            } else {
              this.$deleteFile(urllist)
            }
            this.loading = false
          }
          this.isLoading = false

        })




    },
  },
  computed: {},
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_data_dictionary'
          this.$store.commit('set_page_title', 'label_edit_data_dictionary')
        }
        else {
          this.$route.meta.title = 'label_view_data_dictionary'
          this.$store.commit('set_page_title', 'label_view_data_dictionary')
        }
      }, immediate: true
    }
  },
  beforeDestroy() { },
}
</script>

<style scoped>
.data_dict /deep/ .v-menu__content {
  min-width: 400px !important;
}
.iconGroup {
  position: relative;
}
.returnBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 130px;
}
.editBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 70px;
}
.delBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 10px;
}
</style>
